import { usingGet, usingPost, createProxyUrl } from '@ocean/api'
import { SessionUtils } from '@ocean/utils'
import { UserUtils } from 'utils'
import { ChangePasswordParams, ChangeEmailFormParams } from 'modules/Profile/types'

export const getComplianceHistoryOverview = () => {
  const { login: userId } = UserUtils.getUserAccountInfo()
  return usingGet(`Trainings/GetComplianceHistoryOverview?userId=${userId}`)
}

export const getPersonalInformation = () => {
  const { login: userId } = UserUtils.getUserAccountInfo()
  return usingGet(`Personnel/GetPerson/${userId}`)
}

export const getUserPhotoSource = () => {
  const sessionToken = SessionUtils.getSessionToken() || ''
  return createProxyUrl(`Personnel/getPhoto?token=${sessionToken}`)
}

export const changeUserEmail = ({ email }: ChangeEmailFormParams) => {
  const { login: userId } = UserUtils.getUserAccountInfo()
  return usingPost(`Accounts/ChangeEmail`, {
    id: userId,
    newEmail: email,
  })
}

export const changeUserPassword = (formData: ChangePasswordParams) => {
  const { newPassword, oldPassword: currentPassword } = formData
  const { login: userId } = UserUtils.getUserAccountInfo()
  return usingPost(`Accounts/ChangePassword`, {
    id: userId,
    newPassword,
    currentPassword,
  })
}
